// extracted by mini-css-extract-plugin
export default {"main":"welcome_main__0yxPn","heading":"welcome_heading__bQxZc","buttons":"welcome_buttons__wYe99"};